import React from "react";

/**
 * Renders a questionnaire question title.
 * Mandatory questions get a red asterisk; optional questions stay plain.
 */
const QuestionTitle = ({ t, title, isMandatory = false }) => {
  return (
    <>
      {t(title)}
      {isMandatory ? <span className="text-danger"> *</span> : null}
    </>
  );
};

export default QuestionTitle;
